import React from "react";
import "../styles/Header.css";
import Navbar from "./Navbar";
const Header = () => (
  <header className="header">
    <div className="inner">
    <a id="site-name" href="https://crichbaptistchurch.org/">Crich Baptist Church - Derbyshire, UK</a>
    <p>Reformed & Evangelical - Teaching the Doctrines of Grace</p>
    
    </div>
    
    </header>
);

export default Header;
